import { render, staticRenderFns } from "./articlesList.vue?vue&type=template&id=a3b7e61e&scoped=true&"
import script from "./articlesList.vue?vue&type=script&lang=js&"
export * from "./articlesList.vue?vue&type=script&lang=js&"
import style0 from "./articlesList.vue?vue&type=style&index=0&id=a3b7e61e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b7e61e",
  null
  
)

export default component.exports